import axios from 'axios';
import { settingsConfig } from 'configs/settingsConfig';

export const GET_HOME_DATA = 'GET HOME DATA';
export const SET_HOME_DATA_LOADER = 'SET HOME DATA LOADER';

export const GET_CATEGORY_DATA = 'GET CATEGORY DATA';
export const SET_CATEGORY_DATA_LOADER = 'SET CATEGORY DATA LOADER';

export const GET_PRODUCT_DETAILS = 'GET PRODUCT DETAILS';
export const SET_PRODUCT_DETAILS_LOADER = 'SET PRODUCT DETAILS LOADER';

export function getHomeData() {
	const request = axios.get(settingsConfig.api_url + 'home/');
	return (dispatch) =>
		request.then((response) => {
			dispatch({
				type: GET_HOME_DATA,
				payload: response.data
			});
		});
}
export function setHomeDataLoader(value) {
	return {
		type: SET_HOME_DATA_LOADER,
		payload: value
	};
}

export function getCategoryData() {
	const request = axios.get(settingsConfig.api_url + 'product/');
	return (dispatch) =>
		request.then((response) => {
			dispatch({
				type: GET_CATEGORY_DATA,
				payload: response.data
			});
		});
}
export function setCategoryDataLoader(value) {
	return {
		type: SET_CATEGORY_DATA_LOADER,
		payload: value
	};
}

export function getProductDetails(productId) {
	const request = axios.get(settingsConfig.api_url + 'product/' + productId + '/');
	return (dispatch) =>
		request.then((response) => {
			dispatch({
				type: GET_PRODUCT_DETAILS,
				payload: response.data
			});
		});
}
export function setProductDetailsLoader(value) {
	return {
		type: SET_PRODUCT_DETAILS_LOADER,
		payload: value
	};
}
